import { useAppSelector } from '../store/hooks'
import type { Bootstrap } from '../types/storefront'

/** Only call below <TenantProvider>, where bootstrap is guaranteed loaded. */
export function useTenant(): { slug: string; bootstrap: Bootstrap } {
  const slug = useAppSelector((s) => s.tenant.slug)
  const bootstrap = useAppSelector((s) => s.tenant.bootstrap)
  if (!slug || !bootstrap) throw new Error('useTenant() used outside <TenantProvider>')
  return { slug, bootstrap }
}
